module.exports = __webpack_public_path__ + "img/mastercard.fd48a9ba.png";